import * as i0 from '@angular/core';
import { EventEmitter, Directive, Input, Output, HostListener, NgModule } from '@angular/core';

class DelayedHoverDirective {
    constructor() {
        this.smDelayedHover = 0;
        this.delayedHover = new EventEmitter();
    }
    onMouseEnter(evt) {
        this.clearTimer();
        this._timer = setTimeout(() => {
            this.clearTimer();
            this.delayedHover.emit(evt);
        }, this.smDelayedHover);
    }
    onMouseLeave() {
        this.clearTimer();
    }
    clearTimer() {
        if (this._timer) {
            clearTimeout(this._timer);
            delete this._timer;
        }
    }
    ngOnDestroy() {
        this.clearTimer();
    }
}
DelayedHoverDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: DelayedHoverDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
DelayedHoverDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.6", type: DelayedHoverDirective, selector: "[smDelayedHover]", inputs: { smDelayedHover: "smDelayedHover" }, outputs: { delayedHover: "delayedHover" }, host: { listeners: { "mouseenter": "onMouseEnter($event)", "mouseleave": "onMouseLeave()" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: DelayedHoverDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[smDelayedHover]',
                }]
        }], propDecorators: { smDelayedHover: [{
                type: Input
            }], delayedHover: [{
                type: Output
            }], onMouseEnter: [{
                type: HostListener,
                args: ['mouseenter', ['$event']]
            }], onMouseLeave: [{
                type: HostListener,
                args: ['mouseleave']
            }] } });

class DelayedHoverDirectiveModule {
}
DelayedHoverDirectiveModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: DelayedHoverDirectiveModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DelayedHoverDirectiveModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.6", ngImport: i0, type: DelayedHoverDirectiveModule, declarations: [DelayedHoverDirective], exports: [DelayedHoverDirective] });
DelayedHoverDirectiveModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: DelayedHoverDirectiveModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.6", ngImport: i0, type: DelayedHoverDirectiveModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DelayedHoverDirective
                    ],
                    imports: [],
                    exports: [DelayedHoverDirective],
                    providers: [],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { DelayedHoverDirective, DelayedHoverDirectiveModule };
